import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import ace074741ba1ceaa163435fa2014d9347b from "./generated-95efd37f-d9bd-4b92-9078-d33a54256a13.json";

import ab0b85e66b5d3e049afec7f12332bae08b from "./generated-728f755b-8410-4929-a3ba-13433a3095eb.json";

import a9c4849537b64a829f83e14e9081374abb from "./generated-f0f6937f-c02a-4073-a8e0-30583ea555e7.json";

import afd818f3dc959e7f9f5a9872e7a568e6bb from "./generated-05611dc3-e044-4601-ab9f-d2ef36ac4cd1.json";

import a0e8249eb7fa287117032af60c9de4f5ab from "./generated-02a57876-ab28-4387-8e0c-65795aa75902.json";

import a574e1e9f3d5e42ee2ab242dc5b7e5f1ab from "./generated-993331c0-5142-4752-a6e2-9e749054cf6b.json";

import abc0ba9d6c2d4d206f701af560739d675b from "./generated-d1b0d11b-d1a8-4100-aaa4-c452acc5ec6e.json";

import a1f419588f5b7157748e5fe08a7ea05ffb from "./generated-d2c41d2f-64b1-4264-b15e-a41c51363e8a.json";

import a57268840150d7afb701c23d21509d66db from "./generated-77c76079-fa4f-4f52-bb84-67e47a30b8a6.json";

import ad159853a12429c8ff9ed91d615dacb3fb from "./generated-c238fe77-5b25-4ed6-a6e1-7e114c7aa6a3.json";

import a7e52dae928090c60bffd0255a0305998b from "./generated-c0fa59fc-066a-4555-a36f-e66fdbc9bfcf.json";

import ae7f1925f14df06d8972a6e209b2d44f4b from "./generated-33f60f1b-0af9-48c6-950b-7487d281f58d.json";

import aadc30465081ccb09348489d3f62e8f80b from "./generated-e49356f7-5acf-45f6-833c-30e5b4c04975.json";

import a70362e8c1770a5725e1491eda1d22e57b from "./generated-8667ce8d-92fb-4823-a82d-062cc17e2aa9.json";

import a99cc823dbb5099acac83935bbbc22ab4b from "./generated-ffb054f4-40f7-4c62-9b6d-d9ceb2ab835b.json";

import a3a483ec0caf8de5da37a97e9be61bcfdb from "./generated-23c3e0d0-cda9-4b1e-b4ef-4f632b521759.json";

import ae41e0ab6425a42798d37f111e6e496d5b from "./generated-b3d45135-8fe2-494e-bd43-6ecceef0ea6a.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(ace074741ba1ceaa163435fa2014d9347b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(ab0b85e66b5d3e049afec7f12332bae08b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a9c4849537b64a829f83e14e9081374abb);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(afd818f3dc959e7f9f5a9872e7a568e6bb);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a0e8249eb7fa287117032af60c9de4f5ab);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a574e1e9f3d5e42ee2ab242dc5b7e5f1ab);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(abc0ba9d6c2d4d206f701af560739d675b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a1f419588f5b7157748e5fe08a7ea05ffb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a57268840150d7afb701c23d21509d66db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(ad159853a12429c8ff9ed91d615dacb3fb);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a7e52dae928090c60bffd0255a0305998b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(ae7f1925f14df06d8972a6e209b2d44f4b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a57268840150d7afb701c23d21509d66db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(aadc30465081ccb09348489d3f62e8f80b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a70362e8c1770a5725e1491eda1d22e57b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a57268840150d7afb701c23d21509d66db);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a99cc823dbb5099acac83935bbbc22ab4b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a3a483ec0caf8de5da37a97e9be61bcfdb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(ae41e0ab6425a42798d37f111e6e496d5b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a99cc823dbb5099acac83935bbbc22ab4b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */